// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1tjdT","title":"AfterBackImages_title__2bZCN","images":"AfterBackImages_images__nd5jP"};